import React, { Component } from 'react';
import { Modal, Input, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input;

const Config = {
    'returned': {
        title: '退回原因',
        url: API_URL.evaluate.clinicalReturnEvaluation,
    },
    'unacceptable': {
        title: '不承接原因',
        url: API_URL.evaluate.clinicalNonAcceptanceEvaluation,
    },
}

class ReturnModal extends Component {
    state = {
        params: {},
        config: {},
        visible: false,
        loading: false,
    }

    show = (record = {}, type) => {
        this.setState({
            params: { ...record },
            visible: true,
            config: Config[type],
        });
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
        });
    }

    handleChange = (value) => {
        const { params } = this.state;
        params.remark = value;
        this.setState({ params });
    }

    submit = () => {
        const { params, config } = this.state;
        const { remark, evaluateRecordId } = params;
        if (!remark) {
            return message.warning(`请输入${config.title}`)
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: config.url,
            data: {
                remark,
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, params, config, loading } = this.state;
        const { remark } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={`${config.title}`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="450px"
            >
                <div className="modal-content" style={{ padding: '10px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{width: '30%'}}>{asterisk}{`${config.title}:`}</div>
                            <div className="item-right" style={{width: '60%'}}>
                                <TextArea
                                    placeholder='请输入'
                                    rows={4}
                                    value={remark}
                                    onChange={e => this.handleChange(e.target.value)}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ReturnModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/ReturnModal.js